<template>
  <!-- <v-app> -->
  <div id="app">
    <nav class="navigation_holder">
      <div id="nav_ul">
        <router-link
          :to="$route.params.lat_lng ? '/' + $route.params.lat_lng : '/'"
        >
          <div class="open_div">
            <span class="icon icon-pl iconsong"></span>
          </div>
        </router-link>
        <router-link
          :to="
            $route.params.lat_lng
              ? '/concerts/' + $route.params.lat_lng
              : '/concerts'
          "
        >
          <div class="open_div">
            <span class="icon-calendar boxypl"></span>
          </div>
        </router-link>
        <router-link :to="'/saved'">
          <div class="open_div">
            <span class="iconfavorite boxypl"></span>
          </div>
        </router-link>
      </div>
    </nav>
    <router-view />
  </div>

  <!-- </v-app> -->
</template>

<script>
import { getSpotifyToken } from "@/utils/spotify-token";
export default {
  name: "app",
  beforeCreate() {
    const rightNow = new Date();
    const expires = new Date(sessionStorage.getItem("expires"));
    if (!sessionStorage.accessToken || rightNow > expires) {
      getSpotifyToken();
    }
    // if (window.location.hash.indexOf("access_token") > -1) {
    //   sessionStorage.accessToken = window.location.hash.replace(
    //     "#access_token=",
    //     ""
    //   );
    // //   window.location.href = sessionStorage.hash
    // //     ? `${window.location.origin}/${sessionStorage.hash}`
    // //     : (window.location = window.location.origin);
    // // }
  }
};
</script>

<style>
fieldset {
  border: none;
}
#app {
  font-family: "PT Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

.navigation_holder a.router-link-exact-active span:before,
.navigation_holder a.router-link-active span:before {
  background: #c53526;
  color: white;
  padding: 5px;
  border: 1px dotted white;
  border-radius: 5px;
}

.map {
  height: calc(100vh - 125px);
  width: 100%;
  position: relative;
  overflow: hidden;
  /* top: -22px; */
}

.home,
.concerts {
  margin-top: 20px;
}
[v-cloak] {
  display: none;
}

#genres {
  height: 50%;
  position: fixed;
  top: calc(50% - 50px);
  overflow: scroll;
  width: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.9);
  padding: 12px;
  border-top: 3px solid #c53526;
}

#playlist {
  margin-bottom: 50px;
  height: calc(100% - 155px);
}

.scroll-leave-to,
.scroll-enter {
  transform: translateY(100%);
}
.scroll-enter-active,
.scroll-leave-active {
  transition: all 1.5s ease;
}

.scroll-half-leave-to,
.scroll-half-enter {
  transform: translateY(100%);
}
.scroll-half-enter-active,
.scroll-half-leave-active {
  transition: all 1.5s ease;
}

.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1.5s ease;
}

.fade-scroll-leave-to,
.fade-scroll-enter {
  transform: translateY(100%);
  opacity: 0;
  /* transform: translateX(155px) rotate(30deg); */
}
.fade-scroll-enter-active,
.fade-scroll-leave-active {
  transition: all 1.5s ease;
}

.scroll-from-top-leave-to,
.scroll-from-top-enter {
  transform: translateY(-100%);
}
.scroll-from-top-enter-active,
.scroll-from-top-leave-active {
  transition: all 1.5s ease;
}

.fade-in-scale,
.fade-in-scale-enter {
  transform: scale(0);
  opacity: 0;
}

.fade-in-scale-leave-active {
  opacity: 0;
  transform: scale(1);
}

.fade-in-scale-enter-active,
.fade-in-scale-leave-active {
  transition: all 1s ease;
}

.loading-container {
  position: absolute;
  width: 100%;
  height: 90vh;
  background: rgba(255, 255, 255, 0.75);
  z-index: 1001;
}

.noscroll,
.no-scroll {
  overflow: hidden;
}
.toggle-container {
  position: relative;
  padding: 8px;
  z-index: 101;
}
.exact-location {
  text-align: left;
  margin: 0 24px;
}
.toggle-buttons {
  position: fixed;
  top: 90px;
  right: 24px;
}

.toggle-buttons button:disabled {
  color: gray;
}

.toggle-buttons button:disabled:hover {
  color: gray;
}

.no-styles {
  box-shadow: none;
  outline: none;
  border: none;
  font-size: 20px;
}

.toggle {
  padding: 5px;
  border-radius: 5px;
  border: 1px dotted white;
  margin-right: 12px;
  font-size: 20px;
}

.toggle span:before {
  /* padding: 5px; */
}

.toggle span.active:before {
  font-size: 20px;
}

.cards {
  padding: 0 9px 0 24px;
}

#info article {
  position: relative;
  top: 25%;
}

.info-footer {
  position: relative;
  width: 30px;
  left: calc(50% - 30px);
}

.iconarrow-up {
  font-size: 30px;
}

.icon-container {
  position: fixed;
  top: 0px;
}
</style>
